import React, { useState } from 'react';

const Header = ({ onGetStarted }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light commercial-navbar">
      <div className="container-fluid">
        <a className="navbar-brand" href="/" onClick={closeMenu}>
          <img src="/logo.png" alt="VowAuthor - Professional Wedding Vow Generator" className="logo-img" />
        </a>
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
          style={{ marginRight: '1rem', padding: '0.5rem' }}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <button className="nav-link btn btn-link" onClick={(e) => { e.preventDefault(); closeMenu(); onGetStarted(); }} style={{ border: 'none', background: 'none', color: 'inherit', textDecoration: 'none', padding: '0.5rem 1rem', display: 'block', width: '100%', textAlign: 'left' }}>Write My Vows</button>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/redeem" onClick={closeMenu}>Redeem Code</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/blog" onClick={closeMenu}>Blog</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/help" onClick={closeMenu}>Help</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
